import { render, staticRenderFns } from "./SignupEDD.vue?vue&type=template&id=0070d4b8&scoped=true&"
import script from "./SignupEDD.vue?vue&type=script&lang=js&"
export * from "./SignupEDD.vue?vue&type=script&lang=js&"
import style0 from "./SignupEDD.vue?vue&type=style&index=0&lang=css&"
import style1 from "./SignupEDD.vue?vue&type=style&index=1&id=0070d4b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0070d4b8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAlert,VBtn,VCol,VIcon,VRow,VSelect,VTextField})
